$(function () {
  const btn = $("#LoadMore");

  btn.on("click", async function (e) {
    const nextUrl = btn.data("next-url");
    if (!nextUrl) return;
    btn.prop("disabled", true).text("読み込み中...");
    try {
      const res = await fetch(nextUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // 次ページのグリッドと次URLを取得
      const nextGrid = doc.getElementById("items");
      const nexBtn = doc.getElementById("LoadMore");

      if (nextGrid) {
        $("#items").append(nextGrid.innerHTML);
      }

      const newNextUrl = nexBtn?.dataset?.nextUrl;

      if (newNextUrl) {
        // jQueryのdataキャッシュと属性の両方を更新しておく
        btn.data("next-url", newNextUrl);
        btn.attr("data-next-url", newNextUrl);

        btn.prop("disabled", false).text("もっと見る");
      } else {
        btn.remove();
      }
    } catch (err) {
      console.error(err);
      btn.prop("disabled", false).text("もっと見る");
    }
  });
});
